import { useState } from 'react';
import { MdWarningAmber } from 'react-icons/md';
import classnames from 'classnames';
import { useNodesEdges } from '../contexts/useNodesEdges';

const Warnings = () => {
    const [showFull, setShowFull] = useState(false);
    const { totalOrderedFlows, flowOrder, nodes, incompleteNodeIds } = useNodesEdges();

    const moreThanOneFlow = totalOrderedFlows > 1;
    const flowDoesNotStartWithSection = !!flowOrder.length && flowOrder[0]?.number !== '1';
    const nodesOutsideFlow = flowOrder.length !== nodes.length;
    const hasIncompleteNodes = incompleteNodeIds.length > 0;

    const classes = classnames('warnings', { extended: showFull });

    const hasErrors =
        moreThanOneFlow || flowDoesNotStartWithSection || nodesOutsideFlow || hasIncompleteNodes;

    const errorCount = [
        moreThanOneFlow,
        flowDoesNotStartWithSection,
        nodesOutsideFlow,
        hasIncompleteNodes,
    ].filter(Boolean).length;

    if (!hasErrors) return null;
    return (
        <button className={classes} onClick={() => setShowFull(!showFull)}>
            <div className="summary">
                <span className="icon">
                    <MdWarningAmber size={26} />
                </span>
                <span className="count">{`Flow contains ${errorCount} error${
                    errorCount > 1 ? 's' : ''
                }`}</span>
                {showFull ? (
                    <span className="close-icon">{'x'}</span>
                ) : (
                    <span className="expand-icon">{'<'}</span>
                )}
            </div>
            <div className="details">
                {hasIncompleteNodes && <div className="error">Incomplete nodes are present</div>}
                {flowDoesNotStartWithSection && (
                    <div className="error">Flow does not start with a Section</div>
                )}
                {nodesOutsideFlow && (
                    <div className="error">There are nodes outside of the flow</div>
                )}
                {moreThanOneFlow && (
                    <div className="error">There is more than one flow present</div>
                )}
            </div>
        </button>
    );
};

export default Warnings;
